<template>
  <div class="animated fadeIn">
      <div class="tos-modal modal-body">
        <div class="wrapper">
          <!-- <pdf
            v-for="i in 3"
            :key="i"
            src="https://lighthouse-pdf-images.s3-us-west-2.amazonaws.com/NAI_1513887977_5_Lighthouse.-.End.User.Agreement.Final.pdf"
            :page="i"
            style="height: 100%"
          ></pdf> -->
        </div>

      <p>
        THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE “I ACCEPT” BUTTON BELOW OR BY ACCESSING OR USING THE
        LIGHTHOUSE PLATFORM (“LIGHTHOUSE”). BY CLICKING ON THE “I ACCEPT” BUTTON BELOW OR BY ACCESSING OR
        USING LIGHTHOUSE YOU (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B)
        REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, POWER, AND AUTHORITY TO ENTER INTO THIS AGREEMENT
        AND, IF ENTERING INTO THIS AGREEMENT FOR AN ORGANIZATION, THAT YOU HAVE THE LEGAL AUTHORITY TO BIND
        THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS.
        IF YOU DO NOT AGREE TO THESE TERMS, PLEASE DO NOT USE LIGHTHOUSE. IF YOU DO NOT ACCEPT THESE TERMS,
        YOU MAY NOT ACCESS OR USE LIGHTHOUSE.
      </p>
      <p>
        Allies Against Slavery, a Texas nonprofit corporation with a company offices located at PO Box 684284, Austin, Texas 78768 (“Allies”) and the
        legal entity or individual that has access to or use of Lighthouse (“User” or “you” and, together with Allies, the “Parties”) hereby enter into this
        End User Agreement (“EUA”).Allies Against Slavery, a Texas nonprofit corporation with a company offices located at PO Box 684284, Austin, Texas 78768 (“Allies”) and the
        legal entity or individual that has access to or use of Lighthouse (“User” or “you” and, together with Allies, the “Parties”) hereby enter into this
        End User Agreement (“EUA”).
      </p>

      <ol>
        <li>
          <b>Definitions.</b>
          <ol>
            <li>
            "<u>Agreement</u>" means this EUA by and between the Parties,
            including any exhibits, schedules, appendices, or other policies
            (including Allies’ Privacy Policy) referenced herein.
            </li>
            <li>
              "<u>User Data</u>" means information, data, and other content,
              in any form or medium, that is submitted, posted, or otherwise
              transmitted by or on behalf of User through Lighthouse.
            </li>
            <li>
              "<u>Documentation</u>" means user manuals and other
              instructional documentation, in any form or medium, provided by
              Allies regarding Lighthouse.
            </li>
            <li>
              “<u>Intellectual Property Rights</u>” means all intellectual
              property rights, including rights in any patent, patent application,
              trademark (whether registered or unregistered), trademark
              application, trade name, service mark (whether registered or
              unregistered), service mark application, copyright (whether registered
              or unregistered), copyright application, trade secret, confidential
              information, know-how, process, technology, development tool,
              ideas, concepts, design right, moral right, data base right,
              methodology, algorithm or invention.
            </li>
            <li>
              “<u>Law</u>”  means all applicable laws (including those arising
              under common law), statutes, codes, rules, regulations, reporting or
              licensing requirements, ordinances and other pronouncement having
              the effect of law of the United States, any foreign country or any
              domestic or foreign state, county, city or other political subdivision,
              including those promulgated, interpreted or enforced by any
              governmental or regulatory authority, and any order of a court or
              governmental agency of competent jurisdiction in effect as of the
              Effective Date and as they may be created, implemented, enforced,
              enacted, newly interpreted, amended, changed or modified from time
              to time.
            </li>
            <li>
              “<u>Subscription Period</u>” means the period that Lighthouse
              is provided to you via the Software License Agreement between Allies
              and you or your employer.
            </li>
            <li>
              “<u>Third-Party Data</u>” means any data, content, services,
              information, websites, or other materials that are owned by third
              parties and are incorporated into or accessible through Lighthouse.
            </li>
            <li>
              “<u>Third-Party Suppliers</u>” means third party providers of
              Third-Party Data.
            </li>
          </ol>
        </li>
        <li>
          <b>Services.</b>
          <ol>
            <li>
              <u>General</u>.
              The terms and conditions in this Agreement shall
              govern and, where in conflict, supersede all other terms and
              conditions regarding User’s access and use of Lighthouse. This
              Agreement shall continue from the Effective Date and for the
              Subscription Period.
            </li>
            <li>
              <u>Licenses</u>. During the Subscription Period, (a) the User is
              hereby granted a nonexclusive, nontransferable license to access and
              use Lighthouse; and (b) Allies is hereby granted worldwide, royaltyfree, non-exclusive licenses to use, copy, modify, host, distribute and
              publish User Data. No rights are granted to the User other than as
              expressly set forth in this Agreement.
            </li>
            <li>
              <u>No Other Licenses: Restrictions</u>. Allies’ entering into and
              performing the Agreement will not be deemed to assign or license
              (except the licenses expressly set forth above) any Intellectual
              Property Rights of Allies to User or any third party. User agrees not
              to, and will not allow any third party to: (i) publish any results of any
              benchmark tests run on Lighthouse or any components thereof; (ii)
              perform any penetration or load testing without prior written
              consent; (iii) use Lighthouse to build a competitive product or service,
              or copy any ideas, features, functions, or graphics; (iv) use the
              products contrary to the intended purpose, including to send spam or
              violate any applicable Laws; (v) attempt to gain unauthorized access
              to Lighthouse or its related systems or networks; and (vi) use
              Lighthouse to send or store viruses, worms, time bombs, Trojan
              horses or other harmful or malicious code, files, scripts, agents or
              programs.
            </li>
            <li>
              <u>User Responsibilities</u>. User will comply with all applicable
              laws in using Lighthouse. User warrants that the User Data will not
              2 of 3
              give rise to any claims by a third-party. Allies will have no duty to
              monitor User Data. If Allies determines that any User Data fails to
              comply with the terms of this Agreement, in addition to any other
              available remedies, Allies may, at its sole discretion and without
              liability to User, without judicial order and without prior notice to
              User, terminate or suspend Lighthouse or delete relevant User Data.
              As between Allies and User, User will, at its expense, be solely
              responsible and liable for its use of Lighthouse, including obtaining any
              necessary rights or permissions, and other third-party consents,
              required for such use.
            </li>
            <li>
              <u>Allies Responsibilities</u>.
              Allies may process and store User
              Data in the United States or in other countries and territories and may
              transfer and access User Data from other countries, including where
              Allies has operations
            </li>
          </ol>
        </li>
        <li>
          <b>Ownership.</b>
          All Intellectual Property Rights in Lighthouse and
          any materials provided by Allies including the Documentation and any
          copies, improvements, derivative works or other derivations thereof
          (collectively, “<u>IP Deliverables</u>”) are the exclusive property of Allies.
          User will not attempt to (a) obtain or construct any copies of
          Lighthouse (other than any object code made available by Allies); (b)
          modify Lighthouse or the Documentation; (c) reverse engineer or
          otherwise attempt to access the source code of Lighthouse; (d)
          sublicense or otherwise use Lighthouse for the benefit of any third
          party; (e) use Lighthouse in violation of Law; or (f) utilize Lighthouse
          to store or process personally identifiable information of individuals,
          credit card information or other comparable data. User will
          implement commercially reasonable measures to protect against
          unauthorized access to or use of Lighthouse. User retains Intellectual
          Property Rights in the User Data.
        </li>
        <li>
          <b>Improvements and Confidentiality.</b>
          User will reasonably
          cooperate with Allies’ efforts to improve Lighthouse and will provide
          in writing or otherwise communicate to Allies all ideas or suggestions
          it may have regarding such improvements (“User Input”). In addition,
          ideas, works of authorship or other intellectual property relating to
          Lighthouse may be developed by the Parties jointly (“Joint IP” and,
          together with User Input, “Collaboration IP”). In consideration of
          Allies’ undertakings herein, User agrees to assign, and does hereby
          assign, to Allies all Intellectual Property Rights it may have in such
          Collaboration IP and agrees to execute such further documents and
          take such further actions as Allies may reasonably request to
          implement and perfect this assignment.
          <br/>
          You agree that Lighthouse, Third-Party Data, and the Documentation
          and any other information that a reasonable person would consider
          confidential or proprietary relating to Allies or Lighthouse constitute
          Allies’ confidential information (“Confidential Information”). You shall
          maintain the confidentiality of the Confidential Information and limit
          its disclosure to only such other authorized users who are separately
          authorized to use Lighthouse and as have a genuine need to know
          such Confidential Information for the purposes of care coordination.
          You shall (a) hold such Confidential Information in strict confidence in
          accordance with this Agreement; (b) not use any such Confidential
          Information for any purpose other than as set forth in this paragraph;
          and (c) not disclose any such Confidential Information without the
          prior written authorization of Allies.
        </li>
        <li>
          <b>Third-Party Data.</b>
          Allies will not be responsible for any ThirdParty Data or services used by User even if such Third-Party Data is
          accessible via Lighthouse. User acknowledges that Lighthouse
          aggregates and collects Third-Party Data from licensors and parties
          who are not party to this EUA.
        </li>
        <li>
          <b>Warranties.</b>
          Each Party represents and warrants that:
          <ol>
            <li>
              it has full capacity and authority and all necessary
              consents to enter into and to perform this Agreement and to grant the
              rights and licenses referred to in this Agreement and that this
              Agreement represents a binding commitment on it; and
            </li>
            <li>
              it will comply with all applicable Laws in the performance
of its obligations under this Agreement.
            </li>
            <li>
              EXCEPT AS OTHERWISE PROVIDED IN THIS AGREEMENT
              AND TO THE FULLEST EXTENT PERMITTED BY LAW, ALLIES MAKES NO
              REPRESENTATION OR WARRANTY OF OR ABOUT LIGHTHOUSE. TO THE
              EXTENT PERMITTED BY LAW, ALLIES DISCLAIMS ALL OTHER
              WARRANTIES, EXPRESS AND IMPLIED, INCLUDING, BUT NOT LIMITED
              TO, NON-INFRINGEMENT, TITLE, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET
              ENJOYMENT AND QUALITY, OR ARISING FROM A COURSE OF
              DEALING, LAW, USAGE, OR TRADE PRACTICE. NO ORAL OR WRITTEN
              INFORMATION OR ADVICE GIVEN BY ALLIES WILL CREATE ANY OTHER
              WARRANTIES OR IN ANY WAY INCREASE THE SCOPE OR EXTENT OF
              ALLIES’ OBLIGATIONS HEREUNDER. Allies makes no representation,
              warranty, or commitment of any kind with regard to any Third-Party
              Supplier’s compliance with the terms and conditions (e.g.,
              confidentiality, compliance with law) of this Agreement. User
              acknowledges that Third-Party Suppliers or Allies may modify
              Lighthouse, or may release a new version of Lighthouse at any time
              and for any reason, including to address user needs or otherwise
              address competitive demands, to respond to a Law, or to advance
              innovation. Allies or Third-Party Suppliers may from time to time add
              new features, data or functionality to, or remove existing features,
              data or functionality from, Lighthouse they provide or make available.
              Allies makes no representations or warranties or commitments of any
              kind concerning Lighthouse or their use, accuracy, function or
              ownership and shall not be liable in any manner for any
              representation or warranty or commitment of any kind whether
              express or implied or collateral or whether arising by operation of law
              or otherwise. User acknowledges that portions of Lighthouse are
              provided by Third-Party Suppliers whose performance is not
              warranted or guaranteed by Allies.
              <br/>
              USER HEREBY AGREES THAT ALLIES DOES NOT MONITOR LIGHTHOUSE
              OR ANY DATA THEREIN AND THEREFORE IS NOT SUBJECT TO ANY
              REPORTING REQUIREMENTS PURSUANT TO TEXAS FAMILY CODE §
              261.101, ET. AL. IF USER BECOMES AWARE OR HAS “CAUSE TO
              BELIEVE” THAT A CHILD'S PHYSICAL OR MENTAL HEALTH HAS BEEN
              AFFECTED BY ABUSE OR NEGLECT BY ANY PERSON, USER SHALL
              IMMEDIATELY MAKE A REPORT TO LEGAL AUTHORITIES.
            </li>
            <li>
              No forbearance, delay or indulgence by either Party in
              enforcing the provisions of this Agreement shall prejudice or restrict
              the rights of that Party, nor shall any waiver of its rights operate as a
              waiver of any subsequent breach, and no right, power or remedy
              herein conferred upon or reserved for either Party is exclusive of any
              other right, power or remedy available to that Party, and each such
              right, power or remedy shall be cumulative.
            </li>
          </ol>
        </li>
        <li>
          <b>Indemnification and Limitation of Liability</b>
          <ol>
            <li>
              <b>Indemnification.</b>
              User will indemnify, defend and hold
              harmless Allies, the suppliers, and their affiliates, and their directors,
              officers, employees and agents, from and against any and all claims,
              demands, actions, causes of action, damages, loss, deficiency, cost,
              liability and expense, including reasonable attorneys’ fees and
              amounts paid in settlement, resulting from any claim by a third-party,
              suit, action or proceeding connected with or relating to User’s use of
              Lighthouse. Allies will give User prompt written notice of any such
              claim, and User will have the exclusive right to defend any claim and make settlements thereof at its own discretion. Allies may not settle
              or compromise such claim, except with prior written consent of User.
              At User’s cost, Allies will give such assistance and information as User
              may reasonably require to settle or oppose such claims. User will not
              enter into any settlement of any claim that imposes liability or
              restrictions on Allies without the prior written approval of Allies.
            </li>
            <li>
              <b>Limitation of Liability.</b>
              <br/>
              (a) ALLIES’ TOTAL LIABILITY FOR ANY AND ALL LOSSES
              OR DAMAGES ARISING OUT OF OR RELATED TO THIS AGREEMENT
              SHALL BE LIMITED TO, AND SHALL UNDER NO CIRCUMSTANCES
              EXCEED, IN THE AGGREGATE, $100.
              <br/>
              (b) IN NO EVENT WILL ALLIES BE LIABLE FOR ANY
              INCIDENTAL, INDIRECT, SPECIAL, PUNITIVE, EXEMPLARY, OR
              CONSEQUENTIAL COSTS OR DAMAGES OF ANY KIND. WITHOUT
              LIMITING THE FOREGOING, IN NO EVENT WILL ALLIES BE LIABLE FOR
              ANY DOWNTIME COSTS; LOST BUSINESS, REVENUES, LOSS OF
              GOODWILL, OR LOST PROFITS; DAMAGES FOR FAILURE TO REALIZE
              EXPECTED SAVINGS; SHARE PRICE DECLINES, REDUCTION IN BUSINESS
              VALUE, OR LOSS OR UNAVAILABILITY OF OR DAMAGE TO DATA; OR
              SOFTWARE RESTORATION COSTS, WHETHER OR NOT ALLIES WAS
              AWARE OR SHOULD HAVE BEEN AWARE OF THE POSSIBILITY OF SUCH
              COSTS, EXPENSES, OR DAMAGES. NOTHING CONTAINED HEREIN
              SHALL BE CONSTRUED AS EXCLUDING OR LIMITING EITHER PARTY’S
              LIABILITY FOR DEATH OR PERSONAL INJURY CAUSED BY EITHER
              PARTY’S NEGLIGENCE. EACH PARTY ACKNOWLEDGES THAT THESE
              ALLOCATIONS OF LIABILITY WERE AN ESSENTIAL ELEMENT IN ALLIES
              AND USER ENTERING INTO THE AGREEMENT AND AGREE THAT SUCH
              ALLOCATION OF LIABILITY IS REASONABLE AND APPROPRIATE GIVEN
              THE NATURE OF THE AGREEMENT.
            </li>
          </ol>
        </li>
        <li>
          <b>Miscellaneous</b>
          <ol>
            <li>
              <b>Survival.</b>
              The provisions pursuant to Sections 4, 7, and 8
              shall survive termination of this EUA.
            </li>
            <li>
              <b>Force Majeure.</b>
              Neither Party shall be liable for any delay
              in performance or failure to perform its obligations under this
              Agreement due to any cause outside its reasonable control. Such
              delay or failure shall not constitute a breach of this Agreement and
              the time for performance of the affected obligation shall be extended
              by such period as is reasonable.
            </li>
            <li>
              <b>Severability.</b>
              If any of the provisions or part of a provision
              of this Agreement is judged to be illegal or unenforceable, the
              remainder will continue in full force and effect unless the substantive
              purpose of this Agreement would be frustrated by this, in which case
              either Party may terminate this Agreement forthwith on giving written
              notice to the other. Where any provision of this Agreement is deemed
              unenforceable under any applicable local Laws, then the offending
              part shall be deemed excised from this Agreement and replaced by
              equivalent provisions with the same effect to the fullest extent
              possible and permitted by such local Laws.
            </li>
            <li>
              <b>Governing Law.</b>
              This Agreement and any court
              proceedings shall be governed by the laws of the United States and
              the State of Texas, exclusive of the provisions governing conflict of
              laws or any rule that would require or permit the application of the
              laws of any jurisdiction other than those of the State of Texas. Any legal
              suit, action or proceeding arising out of or related to this Agreement
              or the licenses granted hereunder shall be instituted exclusively in the
              federal courts of the United States or the courts of the State of Texas
              in each case located in the city of Austin and County of Travis, and each
              party irrevocably submits to the exclusive jurisdiction of such courts in
              any such suit, action or proceeding. Service of process, summons, notice or other document by mail to such party’s address set forth
              herein shall be effective service of process for any suit, action or other
              proceeding brought in any such court.
            </li>
            <li>
              <b>Other.</b>
              Along with the Software License Agreement, the
              EUA sets forth the entire agreement and understanding of the Parties
              relating to Lighthouse and supersedes all prior and contemporaneous
              oral and written agreements. Headings have been included for
              convenience only and shall not be used in construing any provision
              herein. Nothing contained in any other document submitted by User
              shall in any way add to or otherwise modify the Agreement or any
              Allies data access or license terms under which the User accesses or
              uses Lighthouse.
            </li>
            The terms of this Agreement or other referenced documents
            may be updated by Allies from time to time without notice (but will
            be identified by the last updated date) and may be reviewed anytime
            at <a href="https://alliesagainstslavery.org/notices/" target="_blank">https://alliesagainstslavery.org/notices/</a>. User’s continued access
            to and use of Lighthouse constitutes acceptance of the then-current
            term
          </ol>
        </li>
      </ol>
      </div>
    </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  // import pdf from 'vue-pdf/src/vuePdfNoSss'

  export default {
    name: 'tos-modal',
    // components: {
    //   pdf
    // },
    props: {
      userId: Number
    },
    computed: {
      // Create a computed property that looks at userContextOrganizationGroups and filters out Groups as a result of orgs that are not the records owningOrg
      // Do you have org admin rights for the owningOrg for this record
      ...mapGetters({
        userCurrentContext: 'userCurrentContext'
      })
    },
    methods: {
      showModal () {
        if (this.$refs.tosModal) {
          this.$refs.tosModal.show()
        }
      },
      hideModal () {
        if (this.$refs.tosModal) {
          this.$refs.tosModal.hide()
        }
      },
      handleCancel (e) {
        e.preventDefault()
        alert('You must accept the Terms of Service in order to proceed')
      },
      handleAcceptTos (e) {
        const user = this.$auth.user()
        const userId = user.id

        this.$store.dispatch('userAcceptedTos', { id: userId })
      },
      userTosCheck () {
        const user = this.$auth.user()
        if (user.acceptedTosAt > 0) {
          return false
        }
        return true
      }
    }
  }
</script>

<style scoped>
.tos-modal .modal-body {
  padding: 1rem 2rem;
  line-height: 23px;
}

.tos-modal li {
  margin-bottom: 10px;
}

.tos-modal li ol {
  margin-top: 10px;
  list-style-type: lower-alpha;
}

.tos-modal ol li em {
  font-weight: bold;
  text-decoration: underline;
  font-style: normal;
}

.wrapper {
    overflow-y: auto;
    width: 75%;
    margin: auto;
}

</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/Tos.vue